<template>
  <div>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Adicionar Destino"
      @hide="hideModal"
    >
      <!-- {{ point }} -->
      <!-- {{ waypoint }} -->
      <!-- {{ item }} -->
      <!-- {{ waypointSelected }} -->
      <div class="right">
        <b-button
          @click="openWaypointModalEdit()"
          size="sm"
          :disabled="!canEdit"
        >
          <i class="tim-icons icon-pencil"> </i>
        </b-button>
        <b-button @click="openWaypointModal()" size="sm">
          <i class="tim-icons icon-simple-add"> </i>
        </b-button>
      </div>

      <div v-if="waypoint.length != 0">
        <b-row class="mt-2">
          <b-col>
            <label for="waypoint-name">Ponto de parada: </label>
          </b-col>
          <b-col cols="9" class="mr-4">
            <multiselect
              v-model="waypointSelected"
              label="text"
              track-by="value"
              placeholder="Selecione o ponto de parada"
              :close-on-select="true"
              :showLabels="false"
              :multiple="false"
              :options="waypointsOpt"
              :internal-search="true"
            >
            </multiselect>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="waypoint-name">Endereço: </label>
          </b-col>
          <b-col cols="9" class="mr-4">
            <b-form-input
              id="input-form-name"
              type="text"
              v-model="waypoint.fullAddress"
              :readonly="true"
              :placeholder="$t('workflow.waypoint.waypointFullAddress')"
            >
            </b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="waypoint-name">Operação: </label>
          </b-col>
          <b-col cols="9" class="mr-4">
            <b-form-select
              :options="optionsTripPlanWaypointsType"
              v-model="waypoint.tripPlanWaypointsType"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="waypoint-name">Tempo permanencia: </label>
          </b-col>
          <b-col cols="9" class="mr-4">
            <input-seconds-as-time :seconds.sync="waypoint.secondsStay">
            </input-seconds-as-time>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <label for="waypoint-name">Tempo adicional: </label>
          </b-col>
          <b-col cols="9" class="mr-4">
            <input-seconds-as-time :seconds.sync="waypoint.secondsAdditional">
            </input-seconds-as-time>
          </b-col>
        </b-row>
        <!-- {{ model }} -->
        <b-row class="mt-2 ml-5 map">
          <div v-if="mapEngine === '0'">
            <leaflet-map
              id="map3"
              ref="map"
              :savePath.sync="paths"
              @onInitialized="onMapInitialized"
            >
              <div
                v-for="waypoint in waypointsActive"
                :key="waypoint.sequenceNumber"
              >
                <leaflet-marker
                  v-if="
                    waypointSelected &&
                      waypoint.id.toString() == waypointSelected.value
                  "
                  :latitude="waypoint.latitude"
                  :longitude="waypoint.longitude"
                  marker-style="primary"
                />
                <leaflet-marker
                  v-else
                  :latitude="waypoint.latitude"
                  :longitude="waypoint.longitude"
                  marker-style="secondary"
                  @onClick="onSelectMarker"
                ></leaflet-marker>
              </div>
            </leaflet-map>
          </div>
          <div v-if="mapEngine === '1'">
            <google-map
              style="height: 420px;
            width: 600px;
            max-width: 100%;
            max-height: 100%;"
              :center="{ lat: waypoint.latitude, lng: waypoint.longitude }"
              :zoom="13"
              ref="map"
            >
              <google-map-marker
                v-if="waypointSelected.value != 0"
                :position="{ lat: waypoint.latitude, lng: waypoint.longitude }"
                primary
              />
              <google-map-marker
                v-else
                v-for="waypoint in waypointsActive"
                :key="waypoint.id"
                :position="{ lat: waypoint.latitude, lng: waypoint.longitude }"
                @marker-clicked="onSelectMarkerGoogle"
              />
            </google-map>
          </div>
        </b-row>
      </div>
      <waypoint-modal ref="waypointModal" :point.sync="model"></waypoint-modal>
      <waypoint-modal-edit
        ref="waypointModalEdit"
        :point.sync="model"
        :waypointSelected.sync="waypointSelected"
        :canEdit.sync="canEdit"
      ></waypoint-modal-edit>

      <!-- <pre class="language-json"><code> waypointsActive: {{ waypointsActive  }} </code></pre> -->
      <!-- <pre class="language-json"><code> waypoint: {{ waypoint  }} </code></pre> -->

      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import VueBingMaps from "vue-bing-maps";
import { text } from "d3";
Vue.use(VueBingMaps);
Vue.use(VueBingMaps, { debug: true });

export default {
  name: "PathAddWaypoint",
  props: {
    // point: Array,
    points: Array,
    item: Object
  },
  components: {
    GoogleMap: () => import("@/components_rms/base/googlemaps/GoogleMap.vue"),
    GoogleMapMarker: () =>
      import("@/components_rms/base/googlemaps/GoogleMapMarker.vue"),
    InputSecondsAsTime: () =>
      import("@/components_rms/base/InputSecondsAsTime.vue"),
    WaypointModal: () =>
      import("@/components_rms/workflow/Waypoint/WaypointModal.vue"),
    WaypointModalEdit: () =>
      import("@/components_rms/workflow/Waypoint/WaypointModalEdit.vue"),
    LeafletMap: () => import("@/components_rms/base/leaflet/LeafletMap.vue"),
    LeafletMarker: () =>
      import("@/components_rms/base/leaflet/LeafletMarker.vue")
  },
  data() {
    return {
      mapEngine: localStorage.getItem("mapEngine"),
      model: {},
      submitted: false,
      canEdit: false,
      waypointsActive: [],
      waypointsOpt: [],
      waypointSelected: {
        value: 0,
        text: ""
      },
      paths: [],
      waypoint: {
        id: 0,
        name: "",
        sequenceNumber: 0,
        fullAddress: "",
        tripPlanWaypointsType: "",
        distance: "",
        secondsTravel: "",
        secondsStay: "0",
        secondsAdditional: "0",
        latitude: 0.0,
        longitude: 0.0,
        active: false,
        waypointId: 0
      },
      optionsTripPlanWaypointsType: [
        { value: 1, text: "COLETA" },
        { value: 2, text: "PARADA AUTORIZADA" },
        { value: 3, text: "DESCANSO RECOMENDADO" },
        { value: 4, text: "ENTREGA" }
      ]
    };
  },
  mounted() {
    this.getWaypointOpt();
  },
  methods: {
    show(point) {
      this.$refs.openModal.show();
      if (point != undefined) {
        this.waypoint = point;
        this.waypointSelected.value = point.waypointId.toString();
        this.waypointSelected.text = point.name;
        this.selectedPoint();
        this.canEdit = true;
      } else this.canEdit = false;
    },
    showLatLng(lat, lng) {
      this.$refs.openModal.show();
      this.selectMarker(lat, lng);
      // this.$refs.map.fitBounds([[lat, lng]]);
    },
    openWaypointModal() {
      this.$refs.waypointModal.show();
    },
    openWaypointModalEdit() {
      this.$refs.waypointModalEdit.show(this.waypoint);
    },
    onMapInitialized() {
      this.fitBounds();
    },
    getWaypointOpt() {
      this.$apiWorkflow
        .get("/waypoint/all/")
        .then(response => {
          this.waypointsActive = response.data;
          this.waypointsOpt = [];
          for (let waypoint of this.waypointsActive) {
            this.waypointsOpt.push({
              value: waypoint.id.toString(),
              text: waypoint.name
            });
          }
          // this.waypointsOpt = response.data;
          if (this.model.name != "")
            this.waypointsOpt.forEach(opt => {
              if (opt.text == this.model.name) {
                this.waypointSelected.value = opt.value;
                this.waypointSelected.text = opt.text;
                this.model.id = this.waypointSelected.value;
                this.selectedPoint();
              }
            });
        })
        .catch(error => {
          console.log(error);
        });

      // this.$apiWorkflow.get("/waypoint/dropdown/").then((response) => {
      //   this.waypointsOpt = response.data;
      //   if (this.model.name != "")
      //     this.waypointsOpt.forEach((opt) => {
      //       if (opt.text == this.model.name) {
      //         this.waypointSelected.value = opt.value;
      //         this.waypointSelected.text = opt.text;
      //         this.model.id = this.waypointSelected.value;
      //         this.selectedPoint();
      //       }
      //     });
      // });
    },
    getWaypointById() {
      this.$apiWorkflow
        .get("/waypoint/getById/" + this.waypointSelected.value)
        .then(response => {
          if (this.waypoint.name != response.data.name) {
            let point = {
              id: this.waypoint.id,
              name: response.data.name,
              sequenceNumber: this.waypoint.sequenceNumber,
              fullAddress: response.data.fullAddress,
              tripPlanWaypointsType: this.waypoint.tripPlanWaypointsType,
              distance: "",
              secondsTravel: "",
              secondsStay: this.waypoint.secondsStay,
              secondsAdditional: this.waypoint.secondsAdditional,
              latitude: response.data.latitude,
              longitude: response.data.longitude,
              active: response.data.active,
              waypointId: response.data.id
            };
            this.waypoint = point;
            this.$emit("update:item", this.waypoint);
          }
          if (this.waypoint.name != this.model.name)
            this.model = {
              id: this.waypointSelected.value,
              name: this.waypoint.name,
              fullAddress: this.waypoint.fullAddress,
              latitude: this.waypoint.latitude,
              longitude: this.waypoint.longitude,
              active: this.waypoint.active
            };
        });
    },
    fitBounds() {
      if (!this.waypoint) return;
      if (!this.$refs.map) return;
      if (this.waypoint.latitude != 0.0 && this.waypoint.longitude != 0.0) {
        this.$refs.map.fitBounds([
          [this.waypoint.latitude, this.waypoint.longitude]
        ]);
      }
    },

    save() {
      if (this.points.length == 0) {
        this.waypoint.sequenceNumber = 1;
        this.points.push(this.waypoint);
      } else {
        if (this.waypoint.sequenceNumber == 0) {
          this.waypoint.sequenceNumber = 1;
          this.points.forEach(p => {
            if (p.active) {
              if (p.sequenceNumber >= this.waypoint.sequenceNumber) {
                this.waypoint.sequenceNumber = p.sequenceNumber + 1;
              }
            }
          });
          this.points.push(this.waypoint);
        } else {
          var row = {};
          this.points.forEach(p => {
            if (p.active) {
              if (p.sequenceNumber == this.waypoint.sequenceNumber) {
                row = p;
              }
            }
          });
          let index = this.points.indexOf(row);
          this.points.splice(index, 1);
          this.points.push(this.waypoint);
        }
      }

      this.hideModal();
    },
    hideModal() {
      this.waypointSelected = {
        value: 0,
        text: ""
      };
      this.waypoint = {
        id: 0,
        name: "",
        sequenceNumber: 0,
        fullAddress: "",
        tripPlanWaypointsType: "",
        distance: "",
        secondsTravel: "",
        secondsStay: "0",
        secondsAdditional: "0",
        latitude: 0.0,
        longitude: 0.0
      };
      this.model = {
        id: 0,
        name: "",
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0
      };
      this.canEdit = false;
      this.$refs.openModal.hide();
    },
    selectedPoint() {
      if (this.waypointSelected != null) {
        this.canEdit = true;
        this.getWaypointById();
      } else {
        this.canEdit = false;
        this.waypoint = {
          id: 0,
          name: "",
          sequenceNumber: 0,
          fullAddress: "",
          tripPlanWaypointsType: "",
          distance: "",
          secondsTravel: "",
          secondsStay: "0",
          secondsAdditional: "0",
          latitude: 0.0,
          longitude: 0.0,
          waypointId: 0
        };
        this.model = {
          id: 0,
          name: "",
          fullAddress: "",
          latitude: 0.0,
          longitude: 0.0
        };
        this.waypointSelected = {
          value: 0,
          text: ""
        };
      }
    },
    selectMarker(lat, lng) {
      for (let w of this.waypointsActive) {
        if (w.latitude == lat && w.longitude == lng) {
          this.waypointSelected.value = w.id.toString();
          this.waypointSelected.text = w.nome;
          this.model.id = this.waypointSelected.value;
          this.selectedPoint();
          break;
        }
      }
    },
    selectMarkerByName(name) {
      for (let w of this.waypointsActive) {
        if (w.name == name) {
          this.waypointSelected.value = w.id.toString();
          this.waypointSelected.text = w.nome;
          this.model.id = this.waypointSelected.value;
          this.selectedPoint();
          break;
        }
      }
    },
    onSelectMarker(e) {
      this.selectMarker(e.latlng.lat, e.latlng.lng);
    },
    onSelectMarkerGoogle(e) {
      console.log(e);
      this.selectMarker(e.lat, e.lng);
    }
  },

  watch: {
    waypointSelected() {
      if (this.waypointSelected.value != 0) this.selectedPoint();
    },
    model() {
      this.getWaypointOpt();
      if (this.model.fullAddress != this.waypoint.fullAddress)
        this.waypoint.fullAddress = this.model.fullAddress;
    },
    waypoint() {
      this.fitBounds();
    }
  }
};
</script>
<style>
.leaflet-pane {
  z-index: 0 !important;
}
</style>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.wrapper {
  width: 100%;
  height: 400px;
}
</style>
